import React from 'react';
export const SkeletonGroupContext = React.createContext(undefined);
//# sourceMappingURL=SkeletonGroupAPI.js.map